import React, { useContext, useEffect } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Image } from "semantic-ui-react";
import Box from "@material-ui/core/Box";
import { CallContext } from "../contexts/CallContext";
import TokenContext from "../contexts/TokenContext";
import AppContext from "../contexts/AppContextProvider";
import { getLogger } from "../services/LoggingService";

const logger = getLogger("ScreenPopContainer");
interface IProps {
    drawerOpen: boolean;
    hideWorkflow: boolean;
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function CallTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            <Box>{children}</Box>
        </div>
    );
}
function PersistentCallTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
        <div role="tabpanel" id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            <Box>{children}</Box>
        </div>
    );
}
function ScreenTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            <Box p={3}>{children}</Box>
        </div>
    );
}
function a11yProps(index: any) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
const contactTabHeight = "42px";
const useStyles = makeStyles((theme: Theme) => ({
    splashContainer: {
        flexGrow: 1,
        display: "flex",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
    },
    logo: {
        width: "600px",
    },
    root: {
        flex: 1,
        backgroundColor: theme.palette.background.paper,
        // height: "600",
    },
    rootOpen: {
        position: "absolute",
        top: "64px",
        left: "350px",
        right: "0",
        bottom: "0",
        transition: theme.transitions.create("left", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    rootClosed: {
        position: "absolute",
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        top: "64px",
        left: "54px",
        right: "0",
        bottom: "0",
        transition: theme.transitions.create("left", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    contactAppBar: {
        backgroundColor: "#257CAF",
        height: contactTabHeight,
    },
    tabsRoot: {
        minHeight: contactTabHeight,
        height: contactTabHeight,
    },
    tabRoot: {
        minHeight: contactTabHeight,
        height: contactTabHeight,
    },
    screenPopAppBar: {
        backgroundColor: "#257CAF",
    },
    miniBarStyles: {
        backgroundColor: "#4A4A4A",
    },
    callEndedMajorBarColor: {
        backgroundColor: "#666666",
    },
    majorBarColor: {
        backgroundColor: "#257CAF",
    },
    backgroundDarkGrey: {
        backgroundColor: "",
    },
    screenTabPanel: {
        position: "absolute",
        top: 42 + 48 + "px",
        bottom: 0,
        right: 0,
        left: 0,
        paddingTop: "5px",
        paddingBottom: "5px",
        paddingRight: "5px",
        paddingLeft: "5px",
        backgroundColor: theme.palette.background.paper,
    },
    workflowTabPanel: {
        position: "absolute",
        top: 44 + "px",
        bottom: 0,
        right: 0,
        left: 0,
        paddingTop: "5px",
        paddingBottom: "5px",
        paddingRight: "5px",
        paddingLeft: "5px",
        backgroundColor: theme.palette.background.paper,
    },
    hiddenScreenPop: {
        position: "fixed",
        bottom: 0,
        right: 0,
        width: "1px",
        height: "1px",
    },
}));
const OuterTabs = (props: any) => {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const { contactIdList, contactDict, hideWorkflow } = props;

    useEffect(() => {
        if (hideWorkflow) {
            setValue(value !== 0 ? value - 1 : value);
        } else {
            setValue(value + 1);
        }
    }, [hideWorkflow]);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };
    const [workflowLoaded, setWorkflowLoaded] = React.useState(false);

    useEffect(() => {
        if (contactIdList.length === 0) {
            setValue(0);
        } else {
            setValue(hideWorkflow ? contactIdList.length - 1 : contactIdList.length);
        }
    }, [contactIdList]);

    return (
        <div className={classes.root}>
            <AppBar className={classes.miniBarStyles} position="relative">
                <Tabs
                    classes={{ root: classes.tabsRoot }}
                    TabIndicatorProps={{ style: { background: "white", height: "3px" } }}
                    value={value}
                    onChange={handleChange}
                    aria-label="contact-tabs"
                >
                    {!hideWorkflow && (
                        <Tab
                            classes={{ root: classes.tabRoot }}
                            key="workflow"
                            label="Workflow"
                            {...a11yProps("workflow")}
                        />
                    )}
                    {!!contactDict &&
                        contactIdList
                            .filter(
                                (contactId: string) => contactDict[contactId].contactType !== connect.ContactType.CHAT
                            )
                            .map((contactId: string, index: number) => {
                                const contactObj = contactDict[contactId];
                                return (
                                    <Tab
                                        classes={{ root: classes.tabRoot }}
                                        key={contactId}
                                        label={`${contactObj.connectionType} ${contactObj.contactType} ${index + 1}`}
                                        {...a11yProps(index)}
                                    />
                                );
                            })}
                    {!!contactDict &&
                        contactIdList
                            .filter(
                                (contactId: string) => contactDict[contactId].contactType === connect.ContactType.CHAT
                            )
                            .map((contactId: string, index: number) => {
                                return (
                                    <Tab
                                        classes={{ root: classes.tabRoot }}
                                        key={contactId}
                                        label={`Chat ${index + 1}`}
                                        {...a11yProps(index)}
                                    />
                                );
                            })}
                </Tabs>
            </AppBar>
            <div>
                {/* {contactIdList.length > 0 ? (
                    contactIdList.map((contactId: string, index: number) => (
                        <CallTabPanel key={contactId} value={value} index={index}>
                            <InnerTabs contactObj={contactDict[contactId]} />
                        </CallTabPanel>
                    ))
                ) : (
                    <CallTabPanel value={value} index={0}>
                        <InnerTabs contactObj={{}} />
                    </CallTabPanel>
                )} */}
                {!hideWorkflow && (
                    <PersistentCallTabPanel key="workflow" value={value} index={0}>
                        <PersistentWorkflowTab setWorkflowLoaded={setWorkflowLoaded} />
                    </PersistentCallTabPanel>
                )}
                {contactIdList.map((contactId: string, index: number) => (
                    <CallTabPanel key={contactId} value={value} index={hideWorkflow ? index : index + 1}>
                        <AgentInfoTab
                            workflowLoaded={workflowLoaded}
                            contactObj={contactDict ? contactDict[contactId] : {}}
                        />
                    </CallTabPanel>
                ))}
            </div>
        </div>
    );
};
const ScreenPop = (props: any) => {
    const { url } = props;
    return <iframe className="screenpop-frame" src={url} width="100%" height="100%" />;
};

const WorkflowScreenPop = (props: any) => {
    const { url, onloaded, id } = props;
    return (
        <iframe onLoad={() => onloaded()} id={id} className="screenpop-frame" src={url} width="100%" height="100%" />
    );
};

const HiddenScreenPop = (props: any) => {
    const { url, ready, onloaded } = props;
    return ready && <iframe onLoad={() => onloaded()} src={url} width="100%" height="100%" />;
};
const InnerTabs = (props: any) => {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [workflowLoaded, setWorkflowLoaded] = React.useState(false);
    const { contactObj } = props;

    const { workflowURL, agentSupportURL, showWorkflow, screenPopURL, contactState } = contactObj;

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };
    const handlePopLoad = () => {
        setTimeout(() => {
            setWorkflowLoaded(true);
        }, 2000);
    };
    const handleHiddenLoaded = () => {
        logger.debug("hidden loaded");
    };

    return (
        <div>
            <AppBar
                className={
                    contactState === connect.ContactStateType.ENDED
                        ? classes.callEndedMajorBarColor
                        : classes.majorBarColor
                }
                position="relative"
            >
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="screen-pop-tabs"
                    TabIndicatorProps={{ style: { background: "white", height: "3px" } }}
                >
                    <Tab label="Info" {...a11yProps(0)} />
                    {showWorkflow && <Tab label="Workflow" {...a11yProps(1)} />}
                    {/* <Tab label="Disposition" {...a11yProps(2)} /> */}
                </Tabs>
            </AppBar>
            {showWorkflow ? (
                <div>
                    <ScreenTabPanel value={value} index={0}>
                        <div className={classes.screenTabPanel}>
                            <ScreenPop url={agentSupportURL} />
                        </div>
                    </ScreenTabPanel>
                    <ScreenTabPanel value={value} index={1}>
                        <div className={classes.screenTabPanel}>
                            <WorkflowScreenPop
                                url={workflowURL}
                                onloaded={handlePopLoad}
                                id={`workflow-${contactObj.contactId}`}
                            />
                        </div>
                    </ScreenTabPanel>
                </div>
            ) : (
                <ScreenTabPanel value={value} index={0}>
                    <div className={classes.screenTabPanel}>
                        <ScreenPop url={agentSupportURL} />
                    </div>
                </ScreenTabPanel>
            )}
            <HiddenScreenPop
                onloaded={handleHiddenLoaded}
                ready={workflowLoaded}
                className={classes.hiddenScreenPop}
                url={screenPopURL}
            />
        </div>
    );
};
const AgentInfoTab = (props: any) => {
    const { workflowLoaded, contactObj } = props;
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const { agentSupportURL, screenPopURL } = contactObj;

    const handleHiddenLoaded = () => {
        logger.debug("SEQ hidden loaded");
    };
    return (
        <div>
            <ScreenTabPanel value={value} index={0}>
                <div className={classes.workflowTabPanel}>
                    <ScreenPop url={agentSupportURL} />
                </div>
            </ScreenTabPanel>
            <HiddenScreenPop
                onloaded={handleHiddenLoaded}
                ready={workflowLoaded}
                className={classes.hiddenScreenPop}
                url={screenPopURL}
            />
        </div>
    );
};
const PersistentWorkflowTab = (props: any) => {
    const { setWorkflowLoaded } = props;
    const classes = useStyles();
    const { config } = useContext(AppContext);
    const [value, setValue] = React.useState(0);

    const handlePopLoad = () => {
        setTimeout(() => {
            setWorkflowLoaded(true);
        }, 2000);
    };

    return (
        <ScreenTabPanel value="workflow-screenpop" index="workflow-screenpop">
            <div className={classes.workflowTabPanel}>
                <WorkflowScreenPop
                    url={config.screenPop.defaultWorkflowURL}
                    onloaded={handlePopLoad}
                    id={"workflow-screenpop"}
                />
            </div>
        </ScreenTabPanel>
    );
};
export default function ScreenPopContainer({ drawerOpen, hideWorkflow }: IProps) {
    const classes = useStyles();
    const [contactIdList, setContactIdList] = React.useState<string[] | []>([]);
    const { contactDict } = useContext(CallContext);
    const { busy } = useContext(TokenContext);
    useEffect(() => {
        if (!contactDict) {
            setContactIdList([]);
            return;
        }
        setContactIdList(
            Object.keys(contactDict).filter((cid) => {
                return (
                    [/*connect.ContactStateType.ENDED,*/ connect.ContactStateType.CONNECTED].includes(
                        contactDict[cid].contactState
                    ) || contactDict[cid].contactType === connect.ContactType.CHAT
                );
            })
        );
    }, [contactDict]);

    const content = () => {
        if (!busy && (!hideWorkflow || (contactIdList.length > 0 && contactDict))) {
            return <OuterTabs contactIdList={contactIdList} contactDict={contactDict} hideWorkflow={hideWorkflow} />;
        } else {
            return (
                <div className={classes.splashContainer}>
                    <div className={classes.logo}>
                        <Image src="top-logo.png" />
                    </div>
                </div>
            );
        }
    };

    return <div className={drawerOpen ? classes.rootOpen : classes.rootClosed}>{content()}</div>;
}
